import React, { useState, useRef } from "react";
import {
  IonButton,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonPage,
  IonFooter,
  IonLabel,
} from "@ionic/react";

import { useTranslation } from "react-i18next";
import { useGame } from "context/gameContext";
import { showReward } from "utils/utils";
import { Md2Cup, Md2CupOutline } from "react-icons-ng/md2";

const GetGameCredits = ({
  closeModal,
  subscribeModalCallBack,
  joinLeagueCallBack,
}) => {
  const {
    state: { userGameData, premium },
  } = useGame();
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  async function getMoreCredits(e) {
    e.preventDefault();
    setIsLoading(true);
    try {
      await showReward({ type: "join" });
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
    setIsLoading(false);
  }

  const subscribeModal = (e) => {
    e.preventDefault();
    subscribeModalCallBack();
  };

  const joinLeague = (e) => {
    e.preventDefault();
    joinLeagueCallBack();
  };

  return (
    <IonPage
      style={{
        "--image-url": `url(https://firebasestorage.googleapis.com/v0/b/oles-test-project.appspot.com/o/common%2Fstadium.png?alt=media&token=7075d1e6-b2d6-48e1-ae5e-5f12d570d847)`,
      }}
      className="bg-[image:var(--image-url)] bg-no-repeat bg-center bg-cover"
    >
      <IonHeader mode="ios" className="ion-no-border">
        <IonToolbar mode="ios" class="">
          <IonButtons slot="start">
            <IonButton onClick={closeModal} mode="ios">
              {t("common.cancel")}
            </IonButton>
          </IonButtons>
          <IonTitle className="flex items-center justify-center" mode="ios">
            {t("premium.joinmodal.cta3")}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding transparent bg-gradient-to-b from-headerPrimary/80 to-black/50">
        {!userGameData?.joinLeagueCredits ||
        userGameData?.joinLeagueCredits < 1 ? (
          <div className="flex flex-col h-full justify-center mx-4">
            <Md2CupOutline size="3rem" className="mx-auto text-white" />
            <div className="text-xl font-light text-center text-white pt-2">
              {t("premium.joinmodal.header")}
            </div>
            <div className="text-sm text-center text-white pt-8">
              {t("premium.joinmodal.description")}
            </div>
            <div className="text-sm text-center text-white pt-4">
              {t("premium.joinmodal.subtitle")}
            </div>
          </div>
        ) : (
          <div className="flex flex-col h-full justify-center mx-4">
            <Md2Cup size="3rem" className="mx-auto text-white" />
            <div className="text-xl font-light text-center text-white pt-2">
              {t("feedback.successTitle")}
            </div>
            <div className="text-sm text-center text-white pt-8">
              {t("premium.joinmodal.proceed")}
            </div>
          </div>
        )}
      </IonContent>

      <IonFooter mode="ios" className="transparent bg-black/90 py-2 px-2">
        {!premium &&
        (!userGameData?.joinLeagueCredits ||
          userGameData?.joinLeagueCredits < 1) ? (
          <>
            <IonButton
              color="success"
              expand="block"
              mode="ios"
              type="submit"
              shape="round"
              disabled={isLoading}
              onClick={(e) => subscribeModal(e)}
              className="customButtonNew rounded-md p-0"
            >
              <IonLabel className="text-black">
                {t("premium.joinmodal.cta1")}
              </IonLabel>
            </IonButton>
            <IonButton
              color="light"
              expand="block"
              mode="ios"
              type="submit"
              shape="round"
              fill="outline"
              disabled={isLoading}
              onClick={(e) => getMoreCredits(e)}
              className="customButtonNew rounded-md mt-2 p-0"
            >
              <IonLabel>{t("premium.joinmodal.cta2")}</IonLabel>
            </IonButton>
          </>
        ) : (
          <IonButton
            color="success"
            expand="block"
            mode="ios"
            type="submit"
            shape="round"
            disabled={isLoading}
            onClick={(e) => joinLeague(e)}
            className="customButtonNew rounded-md mt-2 p-0"
          >
            <IonLabel>{t("premium.joinmodal.cta3")}</IonLabel>
          </IonButton>
        )}
      </IonFooter>
    </IonPage>
  );
};

export default GetGameCredits;
